import React, { PropTypes } from 'react';
import { Link, IndexLink } from 'react-router';

import './UserNav.scss';

class UserNavBar extends React.Component {
    render() {
        return (
            <div>
                <div className="user-nav">
                    <IndexLink to="/">ROOT</IndexLink>
                    <IndexLink to="/user">Dash</IndexLink>
                    <Link to="/user/order">New Book Order</Link>
                    <Link to="/user/history">Order History</Link>
                </div>
            </div>
        );
    }
}

export default UserNavBar;



/** WEBPACK FOOTER **
 ** ./src/components/User/UserNav/UserNav.js
 **/